export const typesTableActions = {
  tableView: 'tableView',
  tableAdd: 'tableAdd',
  tableEdit: 'tableEdit',
  tableDelete: 'tableDelete',
  linkButton: 'linkButton',
};
